import { loadView } from '@/router'

export default [
  {
    path: 'account',
    name: 'reports-account',
    component: loadView('Application/Reports/Account'),
    showInAlfred: true,
    alfredTitle: 'Reports - Account'
  }
]
